module.exports = __webpack_public_path__ + "static/media/seasonal_decliner_grey.4d0b016d.svg";